import { di } from 'react-magnetic-di';
import { useActions as useVirtualAgentActions } from '@atlassian/help-center-virtual-agent/src/controllers/conversation-store';
import { useProvider, useActions } from '@atlassian/unified-help-common/src/store/routing';
import { ConversationProvider } from '@atlassian/unified-help-common/src/types';
import { useActions as useAiAnswerActions } from '../../../store/converse';

export const useClearConversation = () => {
    di(useProvider, useVirtualAgentActions, useAiAnswerActions, useActions);

    const { clearConversation: clearAIAnswerConversation } = useAiAnswerActions();
    const { clearConversation: clearVirtualAgentConversation } = useVirtualAgentActions();
    const { setProvider } = useActions();

    const clearConversation = () => {
        clearAIAnswerConversation();
        clearVirtualAgentConversation();
        setProvider(ConversationProvider.VIRTUAL_AGENT);
    };

    return {
        clearConversation,
    };
};
